// extracted by mini-css-extract-plugin
export default {"modal-backdrop":"XAxisFlag_modal-backdrop__1Xbt6","show":"XAxisFlag_show__QyTy2","LinesEllipsis":"XAxisFlag_LinesEllipsis__HWbRt","xAxisFlag":"XAxisFlag_xAxisFlag__47b-q"};